import { useRef as l, useReducer as f, useEffect as u, useState as d } from "react";
import { getCWPEnvironmentForURL as p, APIENDPOINT as h } from "./utils/common-utils.js";
const w = (e) => {
  const n = l({}), t = {
    status: "idle",
    error: null,
    data: []
  }, [s, r] = f((o, c) => {
    switch (c.type) {
      case "FETCHING":
        return { ...t, status: "fetching" };
      case "FETCHED":
        return { ...t, status: "fetched", data: c.payload };
      case "FETCH_ERROR":
        return { ...t, status: "error", error: c.payload };
      default:
        return o;
    }
  }, t);
  return u(() => {
    let o = !1;
    return !e || !e.trim() ? void 0 : ((async () => {
      if (r({ type: "FETCHING" }), n.current[e]) {
        const a = n.current[e];
        r({ type: "FETCHED", payload: a });
      } else
        try {
          const i = await (await fetch(e)).json();
          if (n.current[e] = i, o) return;
          r({ type: "FETCHED", payload: i });
        } catch (a) {
          if (o) return;
          r({ type: "FETCH_ERROR", payload: a.message });
        }
    })(), function() {
      o = !0;
    });
  }, [e]), s;
}, b = () => {
  const [e, n] = d(!1);
  return u(() => {
    window.geofeed = (s) => {
      const r = s.country.toString();
      s.state.toString() === "CA" && r === "US" && n(!0);
    };
    const t = document.createElement("script");
    t.setAttribute(
      "src",
      "https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location/geofeed"
    ), document.head.appendChild(t);
  }, []), e;
}, m = () => {
  const e = p(window.location.href), n = `${h(e).base}halapi/resourcebundles/ampmicrosites.globalnavigation`, { status: t, data: s, error: r } = w(n);
  return r ? {} : {
    oneTrustLabel: t === "fetched" ? s.bundles && s.bundles.default["one-trust"] : null,
    oneTrustUrl: t === "fetched" ? s.bundles && s.bundles.default["one-trust-url"] : null
  };
}, g = () => {
  const [e, n] = d(window.innerWidth < 768);
  return u(() => {
    const t = () => {
      n(window.innerWidth < 768);
    };
    return window.addEventListener("resize", t), () => {
      window.removeEventListener("resize", t);
    };
  }, []), e;
};
export {
  m as a,
  w as b,
  g as c,
  b as u
};
//# sourceMappingURL=hooks-C9VW6Z5w.mjs.map
